
const BASE_URL = 'https://api.coinnexs.com/api/admin';

export interface AdminBtcResponse {
    success: boolean;
    data: {
        address: string;
    };
    message?: string;
}

class AdminBtcService {
    private async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
        const token = localStorage.getItem('coinnexs_token');
        const headers: Record<string, string> = {
            ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
            'Content-Type': 'application/json',
            ...(options.headers as Record<string, string>),
        };

        try {
            const response = await fetch(`${BASE_URL}${endpoint}`, {
                ...options,
                headers,
            });

            const data = await response.json();
            return data as T;
        } catch (error) {
            console.error(`Admin BTC API Error (${endpoint}):`, error);
            throw error;
        }
    }

    async getBtcAddress(): Promise<AdminBtcResponse> {
        return this.request<AdminBtcResponse>('/btc-address');
    }

    async updateBtcAddress(address: string): Promise<AdminBtcResponse> {
        return this.request<AdminBtcResponse>('/btc-address', {
            method: 'POST',
            body: JSON.stringify({ address }),
        });
    }
}

export const adminBtcService = new AdminBtcService();
